/**
 * The Pit — baked by ultra_map_editor. Edit via the editor.
 *
 * Do not hand-edit: this file is regenerated wholesale on the next bake, and
 * hand-written comments/formatting do not survive a bake.
 */
import type { WorldData } from '../../types';

export const map: WorldData = {
  cityName: "The Pit",
  ground: { width: 47.6, depth: 47.6 },
  spawnPoint: { x: 0, z: -16.8 },
  groundTexture: { textureUrl: "/textures/ground-realistic.webp", textureScale: 0.18, textureRotation: 0.1, secondaryUrl: "/textures/ground-stylized.webp", secondaryScale: 0.11, secondaryRotation: -0.4, noiseUrl: "/textures/noise-detailed.webp", noiseScale: 0.05, noiseRotation: 0.15, noiseOffset: 0.02, noiseGain: 0.8 },

  objects: [
    {
      id: "arena-34",
      kind: "prop",
      label: "Barrier",
      position: { x: 0, z: 22.12 },
      size: { w: 0.927, d: 2.4, h: 0.911 },
      color: 0x8a8577,
      interactable: false,
      modelUrl: "/models/objects/obj_jersey-barrier.glb",
      collisionW: 0.927,
      collisionD: 2.4,
      rotationY: 1.571,
    },
    {
      id: "arena-35",
      kind: "prop",
      label: "Barrier",
      position: { x: 2.477, z: 21.981 },
      size: { w: 0.726, d: 2.4, h: 0.599 },
      color: 0x5a5348,
      interactable: false,
      modelUrl: "/models/objects/obj_jersey-wall.glb",
      collisionW: 0.726,
      collisionD: 2.4,
      rotationY: 1.683,
    },
    {
      id: "arena-36",
      kind: "prop",
      label: "Barrier",
      position: { x: 4.922, z: 21.565 },
      size: { w: 0.927, d: 2.4, h: 0.911 },
      color: 0x8a8577,
      interactable: false,
      modelUrl: "/models/objects/obj_jersey-barrier.glb",
      collisionW: 0.927,
      collisionD: 2.4,
      rotationY: 1.795,
    },
    {
      id: "arena-37",
      kind: "prop",
      label: "Barrier",
      position: { x: 7.306, z: 20.879 },
      size: { w: 0.726, d: 2.4, h: 0.599 },
      color: 0x5a5348,
      interactable: false,
      modelUrl: "/models/objects/obj_jersey-wall.glb",
      collisionW: 0.726,
      collisionD: 2.4,
      rotationY: 1.907,
    },
    {
      id: "arena-38",
      kind: "prop",
      label: "Barrier",
      position: { x: 9.598, z: 19.929 },
      size: { w: 0.927, d: 2.4, h: 0.911 },
      color: 0x8a8577,
      interactable: false,
      modelUrl: "/models/objects/obj_jersey-barrier.glb",
      collisionW: 0.927,
      collisionD: 2.4,
      rotationY: 2.02,
    },
    {
      id: "arena-39",
      kind: "prop",
      label: "Barrier",
      position: { x: 11.769, z: 18.73 },
      size: { w: 0.726, d: 2.4, h: 0.599 },
      color: 0x5a5348,
      interactable: false,
      modelUrl: "/models/objects/obj_jersey-wall.glb",
      collisionW: 0.726,
      collisionD: 2.4,
      rotationY: 2.132,
    },
    {
      id: "arena-40",
      kind: "prop",
      label: "Barrier",
      position: { x: 13.792, z: 17.294 },
      size: { w: 0.927, d: 2.4, h: 0.911 },
      color: 0x8a8577,
      interactable: false,
      modelUrl: "/models/objects/obj_jersey-barrier.glb",
      collisionW: 0.927,
      collisionD: 2.4,
      rotationY: 2.244,
    },
    {
      id: "arena-41",
      kind: "prop",
      label: "Barrier",
      position: { x: 15.641, z: 15.641 },
      size: { w: 0.726, d: 2.4, h: 0.599 },
      color: 0x5a5348,
      interactable: false,
      modelUrl: "/models/objects/obj_jersey-wall.glb",
      collisionW: 0.726,
      collisionD: 2.4,
      rotationY: 2.356,
    },
    {
      id: "arena-42",
      kind: "prop",
      label: "Barrier",
      position: { x: 17.294, z: 13.792 },
      size: { w: 0.927, d: 2.4, h: 0.911 },
      color: 0x8a8577,
      interactable: false,
      modelUrl: "/models/objects/obj_jersey-barrier.glb",
      collisionW: 0.927,
      collisionD: 2.4,
      rotationY: 2.468,
    },
    {
      id: "arena-43",
      kind: "prop",
      label: "Barrier",
      position: { x: 18.73, z: 11.769 },
      size: { w: 0.726, d: 2.4, h: 0.599 },
      color: 0x5a5348,
      interactable: false,
      modelUrl: "/models/objects/obj_jersey-wall.glb",
      collisionW: 0.726,
      collisionD: 2.4,
      rotationY: 2.581,
    },
    {
      id: "arena-44",
      kind: "prop",
      label: "Barrier",
      position: { x: 19.929, z: 9.598 },
      size: { w: 0.927, d: 2.4, h: 0.911 },
      color: 0x8a8577,
      interactable: false,
      modelUrl: "/models/objects/obj_jersey-barrier.glb",
      collisionW: 0.927,
      collisionD: 2.4,
      rotationY: 2.693,
    },
    {
      id: "arena-45",
      kind: "prop",
      label: "Barrier",
      position: { x: 20.879, z: 7.306 },
      size: { w: 0.726, d: 2.4, h: 0.599 },
      color: 0x5a5348,
      interactable: false,
      modelUrl: "/models/objects/obj_jersey-wall.glb",
      collisionW: 0.726,
      collisionD: 2.4,
      rotationY: 2.805,
    },
    {
      id: "arena-46",
      kind: "prop",
      label: "Barrier",
      position: { x: 21.565, z: 4.922 },
      size: { w: 0.927, d: 2.4, h: 0.911 },
      color: 0x8a8577,
      interactable: false,
      modelUrl: "/models/objects/obj_jersey-barrier.glb",
      collisionW: 0.927,
      collisionD: 2.4,
      rotationY: 2.917,
    },
    {
      id: "arena-47",
      kind: "prop",
      label: "Barrier",
      position: { x: 21.981, z: 2.477 },
      size: { w: 0.726, d: 2.4, h: 0.599 },
      color: 0x5a5348,
      interactable: false,
      modelUrl: "/models/objects/obj_jersey-wall.glb",
      collisionW: 0.726,
      collisionD: 2.4,
      rotationY: 3.029,
    },
    {
      id: "arena-48",
      kind: "prop",
      label: "Barrier",
      position: { x: 22.12, z: 0 },
      size: { w: 0.927, d: 2.4, h: 0.911 },
      color: 0x8a8577,
      interactable: false,
      modelUrl: "/models/objects/obj_jersey-barrier.glb",
      collisionW: 0.927,
      collisionD: 2.4,
      rotationY: 3.142,
    },
    {
      id: "arena-49",
      kind: "prop",
      label: "Barrier",
      position: { x: 21.981, z: -2.477 },
      size: { w: 0.726, d: 2.4, h: 0.599 },
      color: 0x5a5348,
      interactable: false,
      modelUrl: "/models/objects/obj_jersey-wall.glb",
      collisionW: 0.726,
      collisionD: 2.4,
      rotationY: 3.254,
    },
    {
      id: "arena-50",
      kind: "prop",
      label: "Barrier",
      position: { x: 21.565, z: -4.922 },
      size: { w: 0.927, d: 2.4, h: 0.911 },
      color: 0x8a8577,
      interactable: false,
      modelUrl: "/models/objects/obj_jersey-barrier.glb",
      collisionW: 0.927,
      collisionD: 2.4,
      rotationY: 3.366,
    },
    {
      id: "arena-51",
      kind: "prop",
      label: "Barrier",
      position: { x: 20.879, z: -7.306 },
      size: { w: 0.726, d: 2.4, h: 0.599 },
      color: 0x5a5348,
      interactable: false,
      modelUrl: "/models/objects/obj_jersey-wall.glb",
      collisionW: 0.726,
      collisionD: 2.4,
      rotationY: 3.478,
    },
    {
      id: "arena-52",
      kind: "prop",
      label: "Barrier",
      position: { x: 19.929, z: -9.598 },
      size: { w: 0.927, d: 2.4, h: 0.911 },
      color: 0x8a8577,
      interactable: false,
      modelUrl: "/models/objects/obj_jersey-barrier.glb",
      collisionW: 0.927,
      collisionD: 2.4,
      rotationY: 3.59,
    },
    {
      id: "arena-53",
      kind: "prop",
      label: "Barrier",
      position: { x: 18.73, z: -11.769 },
      size: { w: 0.726, d: 2.4, h: 0.599 },
      color: 0x5a5348,
      interactable: false,
      modelUrl: "/models/objects/obj_jersey-wall.glb",
      collisionW: 0.726,
      collisionD: 2.4,
      rotationY: 3.703,
    },
    {
      id: "arena-54",
      kind: "prop",
      label: "Barrier",
      position: { x: 17.294, z: -13.792 },
      size: { w: 0.927, d: 2.4, h: 0.911 },
      color: 0x8a8577,
      interactable: false,
      modelUrl: "/models/objects/obj_jersey-barrier.glb",
      collisionW: 0.927,
      collisionD: 2.4,
      rotationY: 3.815,
    },
    {
      id: "arena-55",
      kind: "prop",
      label: "Barrier",
      position: { x: 15.641, z: -15.641 },
      size: { w: 0.726, d: 2.4, h: 0.599 },
      color: 0x5a5348,
      interactable: false,
      modelUrl: "/models/objects/obj_jersey-wall.glb",
      collisionW: 0.726,
      collisionD: 2.4,
      rotationY: 3.927,
    },
    {
      id: "arena-56",
      kind: "prop",
      label: "Barrier",
      position: { x: 13.792, z: -17.294 },
      size: { w: 0.927, d: 2.4, h: 0.911 },
      color: 0x8a8577,
      interactable: false,
      modelUrl: "/models/objects/obj_jersey-barrier.glb",
      collisionW: 0.927,
      collisionD: 2.4,
      rotationY: 4.039,
    },
    {
      id: "arena-57",
      kind: "prop",
      label: "Barrier",
      position: { x: 11.838980788798192, z: -18.831458407617113 },
      size: { w: 0.726, d: 2.4, h: 0.599 },
      color: 0x5a5348,
      interactable: false,
      modelUrl: "/models/objects/obj_jersey-wall.glb",
      collisionW: 0.726,
      collisionD: 2.4,
      rotationY: 4.151,
      rotationX: 0,
      rotationZ: 0,
      positionY: 0,
    },
    {
      id: "arena-58",
      kind: "prop",
      label: "Barrier",
      position: { x: 9.664576274457355, z: -20.05925890663357 },
      size: { w: 0.927, d: 2.4, h: 0.911 },
      color: 0x8a8577,
      interactable: false,
      modelUrl: "/models/objects/obj_jersey-barrier.glb",
      collisionW: 0.927,
      collisionD: 2.4,
      rotationY: -1.8400297771276222,
      rotationX: 0,
      rotationZ: 0,
      positionY: 0,
    },
    {
      id: "arena-59",
      kind: "prop",
      label: "Barrier",
      position: { x: 7.306, z: -20.879 },
      size: { w: 0.726, d: 2.4, h: 0.599 },
      color: 0x5a5348,
      interactable: false,
      modelUrl: "/models/objects/obj_jersey-wall.glb",
      collisionW: 0.726,
      collisionD: 2.4,
      rotationY: 4.376,
    },
    {
      id: "arena-60",
      kind: "prop",
      label: "Barrier",
      position: { x: 4.922, z: -21.565 },
      size: { w: 0.927, d: 2.4, h: 0.911 },
      color: 0x8a8577,
      interactable: false,
      modelUrl: "/models/objects/obj_jersey-barrier.glb",
      collisionW: 0.927,
      collisionD: 2.4,
      rotationY: 4.488,
    },
    {
      id: "arena-61",
      kind: "prop",
      label: "Barrier",
      position: { x: 2.477, z: -21.981 },
      size: { w: 0.726, d: 2.4, h: 0.599 },
      color: 0x5a5348,
      interactable: false,
      modelUrl: "/models/objects/obj_jersey-wall.glb",
      collisionW: 0.726,
      collisionD: 2.4,
      rotationY: 4.6,
    },
    {
      id: "arena-62",
      kind: "prop",
      label: "Barrier",
      position: { x: 0, z: -22.12 },
      size: { w: 0.927, d: 2.4, h: 0.911 },
      color: 0x8a8577,
      interactable: false,
      modelUrl: "/models/objects/obj_jersey-barrier.glb",
      collisionW: 0.927,
      collisionD: 2.4,
      rotationY: 4.712,
    },
    {
      id: "arena-63",
      kind: "prop",
      label: "Barrier",
      position: { x: -2.477, z: -21.981 },
      size: { w: 0.726, d: 2.4, h: 0.599 },
      color: 0x5a5348,
      interactable: false,
      modelUrl: "/models/objects/obj_jersey-wall.glb",
      collisionW: 0.726,
      collisionD: 2.4,
      rotationY: 4.825,
    },
    {
      id: "arena-64",
      kind: "prop",
      label: "Barrier",
      position: { x: -4.922, z: -21.565 },
      size: { w: 0.927, d: 2.4, h: 0.911 },
      color: 0x8a8577,
      interactable: false,
      modelUrl: "/models/objects/obj_jersey-barrier.glb",
      collisionW: 0.927,
      collisionD: 2.4,
      rotationY: 4.937,
    },
    {
      id: "arena-65",
      kind: "prop",
      label: "Barrier",
      position: { x: -7.306, z: -20.879 },
      size: { w: 0.726, d: 2.4, h: 0.599 },
      color: 0x5a5348,
      interactable: false,
      modelUrl: "/models/objects/obj_jersey-wall.glb",
      collisionW: 0.726,
      collisionD: 2.4,
      rotationY: 5.049,
    },
    {
      id: "arena-66",
      kind: "prop",
      label: "Barrier",
      position: { x: -9.598, z: -19.929 },
      size: { w: 0.927, d: 2.4, h: 0.911 },
      color: 0x8a8577,
      interactable: false,
      modelUrl: "/models/objects/obj_jersey-barrier.glb",
      collisionW: 0.927,
      collisionD: 2.4,
      rotationY: 5.161,
    },
    {
      id: "arena-67",
      kind: "prop",
      label: "Barrier",
      position: { x: -11.769, z: -18.73 },
      size: { w: 0.726, d: 2.4, h: 0.599 },
      color: 0x5a5348,
      interactable: false,
      modelUrl: "/models/objects/obj_jersey-wall.glb",
      collisionW: 0.726,
      collisionD: 2.4,
      rotationY: 5.273,
    },
    {
      id: "arena-68",
      kind: "prop",
      label: "Barrier",
      position: { x: -13.792, z: -17.294 },
      size: { w: 0.927, d: 2.4, h: 0.911 },
      color: 0x8a8577,
      interactable: false,
      modelUrl: "/models/objects/obj_jersey-barrier.glb",
      collisionW: 0.927,
      collisionD: 2.4,
      rotationY: 5.386,
    },
    {
      id: "arena-69",
      kind: "prop",
      label: "Barrier",
      position: { x: -15.641, z: -15.641 },
      size: { w: 0.726, d: 2.4, h: 0.599 },
      color: 0x5a5348,
      interactable: false,
      modelUrl: "/models/objects/obj_jersey-wall.glb",
      collisionW: 0.726,
      collisionD: 2.4,
      rotationY: 5.498,
    },
    {
      id: "arena-70",
      kind: "prop",
      label: "Barrier",
      position: { x: -17.294, z: -13.792 },
      size: { w: 0.927, d: 2.4, h: 0.911 },
      color: 0x8a8577,
      interactable: false,
      modelUrl: "/models/objects/obj_jersey-barrier.glb",
      collisionW: 0.927,
      collisionD: 2.4,
      rotationY: 5.61,
    },
    {
      id: "arena-71",
      kind: "prop",
      label: "Barrier",
      position: { x: -18.73, z: -11.769 },
      size: { w: 0.726, d: 2.4, h: 0.599 },
      color: 0x5a5348,
      interactable: false,
      modelUrl: "/models/objects/obj_jersey-wall.glb",
      collisionW: 0.726,
      collisionD: 2.4,
      rotationY: 5.722,
    },
    {
      id: "arena-72",
      kind: "prop",
      label: "Barrier",
      position: { x: -19.929, z: -9.598 },
      size: { w: 0.927, d: 2.4, h: 0.911 },
      color: 0x8a8577,
      interactable: false,
      modelUrl: "/models/objects/obj_jersey-barrier.glb",
      collisionW: 0.927,
      collisionD: 2.4,
      rotationY: 5.834,
    },
    {
      id: "arena-73",
      kind: "prop",
      label: "Barrier",
      position: { x: -20.879, z: -7.306 },
      size: { w: 0.726, d: 2.4, h: 0.599 },
      color: 0x5a5348,
      interactable: false,
      modelUrl: "/models/objects/obj_jersey-wall.glb",
      collisionW: 0.726,
      collisionD: 2.4,
      rotationY: 5.947,
    },
    {
      id: "arena-74",
      kind: "prop",
      label: "Barrier",
      position: { x: -21.565, z: -4.922 },
      size: { w: 0.927, d: 2.4, h: 0.911 },
      color: 0x8a8577,
      interactable: false,
      modelUrl: "/models/objects/obj_jersey-barrier.glb",
      collisionW: 0.927,
      collisionD: 2.4,
      rotationY: 6.059,
    },
    {
      id: "arena-75",
      kind: "prop",
      label: "Barrier",
      position: { x: -21.981, z: -2.477 },
      size: { w: 0.726, d: 2.4, h: 0.599 },
      color: 0x5a5348,
      interactable: false,
      modelUrl: "/models/objects/obj_jersey-wall.glb",
      collisionW: 0.726,
      collisionD: 2.4,
      rotationY: 6.171,
    },
    {
      id: "arena-76",
      kind: "prop",
      label: "Barrier",
      position: { x: -22.12, z: 0 },
      size: { w: 0.927, d: 2.4, h: 0.911 },
      color: 0x8a8577,
      interactable: false,
      modelUrl: "/models/objects/obj_jersey-barrier.glb",
      collisionW: 0.927,
      collisionD: 2.4,
      rotationY: 6.283,
    },
    {
      id: "arena-77",
      kind: "prop",
      label: "Barrier",
      position: { x: -21.981, z: 2.477 },
      size: { w: 0.726, d: 2.4, h: 0.599 },
      color: 0x5a5348,
      interactable: false,
      modelUrl: "/models/objects/obj_jersey-wall.glb",
      collisionW: 0.726,
      collisionD: 2.4,
      rotationY: 6.395,
    },
    {
      id: "arena-78",
      kind: "prop",
      label: "Barrier",
      position: { x: -21.565, z: 4.922 },
      size: { w: 0.927, d: 2.4, h: 0.911 },
      color: 0x8a8577,
      interactable: false,
      modelUrl: "/models/objects/obj_jersey-barrier.glb",
      collisionW: 0.927,
      collisionD: 2.4,
      rotationY: 6.508,
    },
    {
      id: "arena-79",
      kind: "prop",
      label: "Barrier",
      position: { x: -20.879, z: 7.306 },
      size: { w: 0.726, d: 2.4, h: 0.599 },
      color: 0x5a5348,
      interactable: false,
      modelUrl: "/models/objects/obj_jersey-wall.glb",
      collisionW: 0.726,
      collisionD: 2.4,
      rotationY: 6.62,
    },
    {
      id: "arena-80",
      kind: "prop",
      label: "Barrier",
      position: { x: -19.929, z: 9.598 },
      size: { w: 0.927, d: 2.4, h: 0.911 },
      color: 0x8a8577,
      interactable: false,
      modelUrl: "/models/objects/obj_jersey-barrier.glb",
      collisionW: 0.927,
      collisionD: 2.4,
      rotationY: 6.732,
    },
    {
      id: "arena-81",
      kind: "prop",
      label: "Barrier",
      position: { x: -18.73, z: 11.769 },
      size: { w: 0.726, d: 2.4, h: 0.599 },
      color: 0x5a5348,
      interactable: false,
      modelUrl: "/models/objects/obj_jersey-wall.glb",
      collisionW: 0.726,
      collisionD: 2.4,
      rotationY: 6.844,
    },
    {
      id: "arena-82",
      kind: "prop",
      label: "Barrier",
      position: { x: -17.294, z: 13.792 },
      size: { w: 0.927, d: 2.4, h: 0.911 },
      color: 0x8a8577,
      interactable: false,
      modelUrl: "/models/objects/obj_jersey-barrier.glb",
      collisionW: 0.927,
      collisionD: 2.4,
      rotationY: 6.956,
    },
    {
      id: "arena-83",
      kind: "prop",
      label: "Barrier",
      position: { x: -15.641, z: 15.641 },
      size: { w: 0.726, d: 2.4, h: 0.599 },
      color: 0x5a5348,
      interactable: false,
      modelUrl: "/models/objects/obj_jersey-wall.glb",
      collisionW: 0.726,
      collisionD: 2.4,
      rotationY: 7.069,
    },
    {
      id: "arena-84",
      kind: "prop",
      label: "Barrier",
      position: { x: -13.792, z: 17.294 },
      size: { w: 0.927, d: 2.4, h: 0.911 },
      color: 0x8a8577,
      interactable: false,
      modelUrl: "/models/objects/obj_jersey-barrier.glb",
      collisionW: 0.927,
      collisionD: 2.4,
      rotationY: 7.181,
    },
    {
      id: "arena-85",
      kind: "prop",
      label: "Barrier",
      position: { x: -11.769, z: 18.73 },
      size: { w: 0.726, d: 2.4, h: 0.599 },
      color: 0x5a5348,
      interactable: false,
      modelUrl: "/models/objects/obj_jersey-wall.glb",
      collisionW: 0.726,
      collisionD: 2.4,
      rotationY: 7.293,
    },
    {
      id: "arena-86",
      kind: "prop",
      label: "Barrier",
      position: { x: -9.598, z: 19.929 },
      size: { w: 0.927, d: 2.4, h: 0.911 },
      color: 0x8a8577,
      interactable: false,
      modelUrl: "/models/objects/obj_jersey-barrier.glb",
      collisionW: 0.927,
      collisionD: 2.4,
      rotationY: 7.405,
    },
    {
      id: "arena-87",
      kind: "prop",
      label: "Barrier",
      position: { x: -7.306, z: 20.879 },
      size: { w: 0.726, d: 2.4, h: 0.599 },
      color: 0x5a5348,
      interactable: false,
      modelUrl: "/models/objects/obj_jersey-wall.glb",
      collisionW: 0.726,
      collisionD: 2.4,
      rotationY: 7.517,
    },
    {
      id: "arena-88",
      kind: "prop",
      label: "Barrier",
      position: { x: -4.922, z: 21.565 },
      size: { w: 0.927, d: 2.4, h: 0.911 },
      color: 0x8a8577,
      interactable: false,
      modelUrl: "/models/objects/obj_jersey-barrier.glb",
      collisionW: 0.927,
      collisionD: 2.4,
      rotationY: 7.63,
    },
    {
      id: "arena-89",
      kind: "prop",
      label: "Barrier",
      position: { x: -2.477, z: 21.981 },
      size: { w: 0.726, d: 2.4, h: 0.599 },
      color: 0x5a5348,
      interactable: false,
      modelUrl: "/models/objects/obj_jersey-wall.glb",
      collisionW: 0.726,
      collisionD: 2.4,
      rotationY: 7.742,
    },
    {
      id: "arena-16",
      kind: "prop",
      label: "Sandbag Wall",
      position: { x: 3.034877872430023, z: 10.470201964865026 },
      size: { w: 3.2, d: 0.464, h: 0.436 },
      color: 0x7a6f52,
      interactable: false,
      modelUrl: "/models/objects/obj_sandbag-wall.glb",
      collisionW: 3.2,
      collisionD: 0.464,
      rotationY: 0.25,
      rotationX: 0,
      rotationZ: 0,
      positionY: 0,
    },
    {
      id: "arena-17",
      kind: "prop",
      label: "Sandbag Wall",
      position: { x: -3.823686684704045, z: -10.339658985867999 },
      size: { w: 3.2, d: 0.464, h: 0.436 },
      color: 0x7a6f52,
      interactable: false,
      modelUrl: "/models/objects/obj_sandbag-wall.glb",
      collisionW: 3.2,
      collisionD: 0.464,
      rotationY: 3.392,
      rotationX: 0,
      rotationZ: 0,
      positionY: 0,
    },
    {
      id: "arena-18",
      kind: "prop",
      label: "Sandbag Wall",
      position: { x: -4.33, z: 12.575 },
      size: { w: 3, d: 0.435, h: 0.409 },
      color: 0x7a6f52,
      interactable: false,
      modelUrl: "/models/objects/obj_sandbag-wall.glb",
      collisionW: 3,
      collisionD: 0.435,
      rotationY: 1.1,
    },
    {
      id: "arena-19",
      kind: "prop",
      label: "Sandbag Wall",
      position: { x: 4.575318669717972, z: -12.094527398751655 },
      size: { w: 3, d: 0.435, h: 0.409 },
      color: 0x7a6f52,
      interactable: false,
      modelUrl: "/models/objects/obj_sandbag-wall.glb",
      collisionW: 3,
      collisionD: 0.435,
      rotationY: -2.0702992065206134,
      rotationX: 0,
      rotationZ: 0,
      positionY: 0,
    },
    {
      id: "arena-20",
      kind: "prop",
      label: "Dumpster",
      position: { x: 8.655, z: -2.812 },
      size: { w: 2.096, d: 1.666, h: 1.5 },
      color: 0x4f5f4a,
      interactable: false,
      modelUrl: "/models/objects/obj_dumpster.glb",
      collisionW: 2.096,
      collisionD: 1.666,
      rotationY: 1.4,
    },
    {
      id: "arena-21",
      kind: "prop",
      label: "Dumpster",
      position: { x: -8.698320694046341, z: 3.6069281988151394 },
      size: { w: 2.096, d: 1.666, h: 1.5 },
      color: 0x4f5f4a,
      interactable: false,
      modelUrl: "/models/objects/obj_dumpster.glb",
      collisionW: 2.096,
      collisionD: 1.666,
      rotationY: 4.542,
      rotationX: 0,
      rotationZ: 0,
      positionY: 0,
    },
    {
      id: "arena-22",
      kind: "prop",
      label: "Dumpster",
      position: { x: 12.811854900908747, z: 4.546525739437133 },
      size: { w: 1.992, d: 1.556, h: 1.4 },
      color: 0x4a5f52,
      interactable: false,
      modelUrl: "/models/objects/obj_dumpster-2.glb",
      collisionW: 1.992,
      collisionD: 1.556,
      rotationY: 2.6,
      rotationX: 0,
      rotationZ: 0,
      positionY: 0,
    },
    {
      id: "arena-23",
      kind: "prop",
      label: "Dumpster",
      position: { x: -13.315, z: -4.326 },
      size: { w: 1.992, d: 1.556, h: 1.4 },
      color: 0x4a5f52,
      interactable: false,
      modelUrl: "/models/objects/obj_dumpster-2.glb",
      collisionW: 1.992,
      collisionD: 1.556,
      rotationY: 5.742,
    },
    {
      id: "arena-24",
      kind: "prop",
      label: "Crates",
      position: { x: 5.597, z: 0.195 },
      size: { w: 2.911, d: 2.772, h: 1.6 },
      color: 0x8a6b3f,
      interactable: false,
      modelUrl: "/models/objects/obj_crates.glb",
      collisionW: 2.911,
      collisionD: 2.772,
      rotationY: 0.6,
    },
    {
      id: "arena-25",
      kind: "prop",
      label: "Crates",
      position: { x: -5.597, z: -0.195 },
      size: { w: 2.911, d: 2.772, h: 1.6 },
      color: 0x8a6b3f,
      interactable: false,
      modelUrl: "/models/objects/obj_crates.glb",
      collisionW: 2.911,
      collisionD: 2.772,
      rotationY: 3.742,
    },
    {
      id: "arena-26",
      kind: "prop",
      label: "Concrete Blocks",
      position: { x: 13.239, z: 10.343 },
      size: { w: 1.977, d: 1.131, h: 1 },
      color: 0x8f8b80,
      interactable: false,
      modelUrl: "/models/objects/obj_blocks-stack.glb",
      collisionW: 1.977,
      collisionD: 1.131,
      rotationY: 2.2,
    },
    {
      id: "arena-27",
      kind: "prop",
      label: "Concrete Blocks",
      position: { x: -13.378396163476896, z: -10.851155798480082 },
      size: { w: 1.977, d: 1.131, h: 1 },
      color: 0x8f8b80,
      interactable: false,
      modelUrl: "/models/objects/obj_blocks-stack.glb",
      collisionW: 1.977,
      collisionD: 1.131,
      rotationY: 0.1540902629230977,
      rotationX: 0,
      rotationZ: 0,
      positionY: 0,
    },
    {
      id: "arena-30",
      kind: "prop",
      label: "Water Tank",
      position: { x: 2.634, z: -7.236 },
      size: { w: 1.775, d: 1.708, h: 2.2 },
      color: 0x6a7a6a,
      interactable: false,
      modelUrl: "/models/objects/obj_tank-water.glb",
      collisionW: 1.775,
      collisionD: 1.708,
      rotationY: 0.4,
    },
    {
      id: "arena-32",
      kind: "prop",
      label: "Wrecked Sedan",
      position: { x: 3.22, z: 0 },
      size: { w: 4.4, d: 3.454, h: 1.318 },
      color: 0x7a4a3a,
      interactable: false,
      modelUrl: "/models/objects/obj_car-rust-5.glb",
      collisionW: 4.4,
      collisionD: 3.454,
      rotationY: 1.78,
      rotationX: 0,
      rotationZ: 0,
      positionY: -0.0820548013490523,
    },
    {
      id: "arena-33",
      kind: "prop",
      label: "Wrecked Sedan",
      position: { x: -3.22, z: 0 },
      size: { w: 4.4, d: 3.454, h: 1.318 },
      color: 0x7a4a3a,
      interactable: false,
      modelUrl: "/models/objects/obj_car-rust-5.glb",
      collisionW: 4.4,
      collisionD: 3.454,
      rotationY: 4.922,
      rotationX: 0,
      rotationZ: 0,
      positionY: -0.09606949639897966,
    },
    {
      id: "arena-90",
      kind: "prop",
      label: "Bulldozer",
      position: { x: -6.818, z: -16.875 },
      size: { w: 5.2, d: 2.863, h: 2.385 },
      color: 0x8a7a2a,
      interactable: false,
      modelUrl: "/models/objects/obj_bulldozer.glb",
      collisionW: 5.2,
      collisionD: 2.863,
      rotationY: 2.269,
    },
    {
      id: "arena-91",
      kind: "prop",
      label: "Wrecked Van",
      position: { x: -10.99, z: -14.066 },
      size: { w: 2.426, d: 5, h: 2.167 },
      color: 0x4a5a4f,
      interactable: false,
      modelUrl: "/models/objects/obj_car-rust-26-van.glb",
      collisionW: 2.426,
      collisionD: 5,
      rotationY: 3.491,
    },
    {
      id: "arena-92",
      kind: "prop",
      label: "Wrecked SUV",
      position: { x: -13.691440381135989, z: 11.50686924590924 },
      size: { w: 1.418, d: 2.833, h: 1.9 },
      color: 0x5a5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_car-rust-13-suv.glb",
      collisionW: 1.418,
      collisionD: 2.833,
      rotationY: -0.8036228499268471,
      rotationX: 0,
      rotationZ: 0,
      positionY: -0.8834098630761094,
    },
    {
      id: "arena-93",
      kind: "prop",
      label: "Bus Wreck",
      position: { x: -17.489, z: -0.611 },
      size: { w: 4.551, d: 9, h: 2.713 },
      color: 0x6a6a3a,
      interactable: false,
      modelUrl: "/models/objects/obj_car-rust-40-bus.glb",
      collisionW: 4.551,
      collisionD: 9,
      rotationY: 3.107,
    },
    {
      id: "arena-94",
      kind: "prop",
      label: "Generator",
      position: { x: 9.45, z: -16.368 },
      size: { w: 2.029, d: 1.746, h: 1.7 },
      color: 0x5a5a52,
      interactable: false,
      modelUrl: "/models/objects/obj_generator-large.glb",
      collisionW: 2.029,
      collisionD: 1.746,
      rotationY: 1,
    },
    {
      id: "arena-95",
      kind: "prop",
      label: "Tanker Trailer",
      position: { x: -5.21, z: 18.168 },
      size: { w: 7.5, d: 2.576, h: 2.818 },
      color: 0x8a8a7a,
      interactable: false,
      modelUrl: "/models/objects/obj_trailer-tanker.glb",
      collisionW: 7.5,
      collisionD: 2.576,
      rotationY: 2.793,
    },
    {
      id: "arena-96",
      kind: "prop",
      label: "Jet Engine",
      position: { x: 15.984, z: -10.977 },
      size: { w: 3.6, d: 2.696, h: 1.581 },
      color: 0x7a7a7a,
      interactable: false,
      modelUrl: "/models/objects/obj_jet-engine.glb",
      collisionW: 3.6,
      collisionD: 2.696,
      rotationY: 1.92,
      rotationX: 0,
      rotationZ: 0,
      positionY: -0.0580311858136687,
    },
    {
      id: "arena-97",
      kind: "prop",
      label: "Floodlight",
      position: { x: 6.403, z: 19.706 },
      size: { w: 2.226, d: 3.594, h: 7 },
      color: 0x6a6a62,
      interactable: false,
      modelUrl: "/models/objects/obj_street-lamp-2.glb",
      collisionW: 2.226,
      collisionD: 3.594,
      rotationY: 3.3,
    },
    {
      id: "arena-98",
      kind: "prop",
      label: "Floodlight",
      position: { x: 20.328, z: -2.423 },
      size: { w: 3.434, d: 2.95, h: 6.6 },
      color: 0x6a6a62,
      interactable: false,
      modelUrl: "/models/objects/obj_street-lamp-3.glb",
      collisionW: 3.434,
      collisionD: 2.95,
      rotationY: -3.070783235310846,
      rotationX: 0,
      rotationZ: 0,
      positionY: 0,
    },
    {
      id: "arena-99",
      kind: "prop",
      label: "Floodlight",
      position: { x: 4.308, z: -20.267 },
      size: { w: 3.641, d: 2.613, h: 7.2 },
      color: 0x6a6a62,
      interactable: false,
      modelUrl: "/models/objects/obj_street-light-1.glb",
      collisionW: 3.641,
      collisionD: 2.613,
      rotationY: 5.9,
    },
    {
      id: "arena-100",
      kind: "prop",
      label: "Floodlight",
      position: { x: -18.623, z: -9.083 },
      size: { w: 2.163, d: 3.492, h: 6.8 },
      color: 0x6a6a62,
      interactable: false,
      modelUrl: "/models/objects/obj_street-lamp-2.glb",
      collisionW: 2.163,
      collisionD: 3.492,
      rotationY: 0.4,
    },
    {
      id: "arena-101",
      kind: "prop",
      label: "Floodlight",
      position: { x: -16.763, z: 12.179 },
      size: { w: 3.642, d: 3.129, h: 7 },
      color: 0x6a6a62,
      interactable: false,
      modelUrl: "/models/objects/obj_street-lamp-3.glb",
      collisionW: 3.642,
      collisionD: 3.129,
      rotationY: 2.7,
    },
    {
      id: "arena-102",
      kind: "prop",
      label: "Utility Post",
      position: { x: 17.512, z: 10.943 },
      size: { w: 1.86, d: 2.588, h: 5.4 },
      color: 0x6a5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_utility-post.glb",
      collisionW: 1.86,
      collisionD: 2.588,
      rotationY: 0.8,
    },
    {
      id: "arena-103",
      kind: "prop",
      label: "Utility Post",
      position: { x: -11.547, z: -17.12 },
      size: { w: 1.722, d: 2.396, h: 5 },
      color: 0x6a5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_utility-post.glb",
      collisionW: 1.722,
      collisionD: 2.396,
      rotationY: 2.2,
    },
    {
      id: "arena-104",
      kind: "prop",
      label: "Pulley Rig",
      position: { x: -19.783, z: 5.673 },
      size: { w: 0.93, d: 0.769, h: 3.4 },
      color: 0x5a5a52,
      interactable: false,
      modelUrl: "/models/objects/obj_pulley.glb",
      collisionW: 0.93,
      collisionD: 0.769,
      rotationY: 1.5,
    },
    {
      id: "arena-105",
      kind: "prop",
      label: "Traffic Light",
      position: { x: 15.346, z: -13.818 },
      size: { w: 1.708, d: 0.408, h: 0.65 },
      color: 0x3a3a3a,
      interactable: false,
      modelUrl: "/models/objects/obj_traffic-light.glb",
      collisionW: 1.708,
      collisionD: 0.408,
      rotationY: 1.7,
    },
    {
      id: "arena-106",
      kind: "prop",
      label: "Sign",
      position: { x: -3.586, z: 20.336 },
      size: { w: 2.184, d: 0.402, h: 2.4 },
      color: 0x7a6a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_sign-2.glb",
      collisionW: 2.184,
      collisionD: 0.402,
      rotationY: 3,
    },
    {
      id: "arena-107",
      kind: "prop",
      label: "Signpost",
      position: { x: 20.037, z: 4.996 },
      size: { w: 1.149, d: 0.166, h: 2.6 },
      color: 0x6a5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_signpost.glb",
      collisionW: 1.149,
      collisionD: 0.166,
      rotationY: 0.3,
    },
    {
      id: "arena-108",
      kind: "prop",
      label: "Broken Tree",
      position: { x: -3.842, z: -18.076 },
      size: { w: 6.278, d: 3.727, h: 3.8 },
      color: 0x4a3f2a,
      interactable: false,
      modelUrl: "/models/objects/obj_tree-broken-1.glb",
      collisionW: 6.278,
      collisionD: 3.727,
      rotationY: 1.1,
    },
    {
      id: "arena-109",
      kind: "prop",
      label: "Broken Tree",
      position: { x: 10.412, z: 15.437 },
      size: { w: 7.608, d: 3.007, h: 3.2 },
      color: 0x4a3f2a,
      interactable: false,
      modelUrl: "/models/objects/obj_tree-broken-2.glb",
      collisionW: 7.608,
      collisionD: 3.007,
      rotationY: 2.4,
    },
    {
      id: "arena-1",
      kind: "prop",
      label: "Fire Barrel",
      position: { x: 2.845, z: 20.241 },
      size: { w: 0.801, d: 1.011, h: 1.15 },
      color: 0x9a4a22,
      interactable: false,
      modelUrl: "/models/objects/obj_fire-barrel.glb",
      collisionW: 0.801,
      collisionD: 1.011,
      rotationY: 0,
    },
    {
      id: "arena-2",
      kind: "prop",
      label: "Fire Barrel",
      position: { x: 14.502, z: 14.004 },
      size: { w: 0.801, d: 1.011, h: 1.15 },
      color: 0x9a4a22,
      interactable: false,
      modelUrl: "/models/objects/obj_fire-barrel.glb",
      collisionW: 0.801,
      collisionD: 1.011,
      rotationY: 1.37,
    },
    {
      id: "arena-3",
      kind: "prop",
      label: "Fire Barrel",
      position: { x: 20.467, z: 2.151 },
      size: { w: 0.801, d: 1.011, h: 1.15 },
      color: 0x9a4a22,
      interactable: false,
      modelUrl: "/models/objects/obj_fire-barrel.glb",
      collisionW: 0.801,
      collisionD: 1.011,
      rotationY: 2.74,
    },
    {
      id: "arena-4",
      kind: "prop",
      label: "Fire Barrel",
      position: { x: 20.65, z: 0 },
      size: { w: 0.801, d: 1.011, h: 1.15 },
      color: 0x9a4a22,
      interactable: false,
      modelUrl: "/models/objects/obj_fire-barrel.glb",
      collisionW: 0.801,
      collisionD: 1.011,
      rotationY: 4.11,
    },
    {
      id: "arena-5",
      kind: "prop",
      label: "Fire Barrel",
      position: { x: 9.596, z: -18.047 },
      size: { w: 0.801, d: 1.011, h: 1.15 },
      color: 0x9a4a22,
      interactable: false,
      modelUrl: "/models/objects/obj_fire-barrel.glb",
      collisionW: 0.801,
      collisionD: 1.011,
      rotationY: 5.48,
    },
    {
      id: "arena-6",
      kind: "prop",
      label: "Fire Barrel",
      position: { x: -2.815, z: -20.033 },
      size: { w: 0.801, d: 1.011, h: 1.15 },
      color: 0x9a4a22,
      interactable: false,
      modelUrl: "/models/objects/obj_fire-barrel.glb",
      collisionW: 0.801,
      collisionD: 1.011,
      rotationY: 0.567,
    },
    {
      id: "arena-7",
      kind: "prop",
      label: "Fire Barrel",
      position: { x: -14.754, z: -14.247 },
      size: { w: 0.801, d: 1.011, h: 1.15 },
      color: 0x9a4a22,
      interactable: false,
      modelUrl: "/models/objects/obj_fire-barrel.glb",
      collisionW: 0.801,
      collisionD: 1.011,
      rotationY: 1.937,
    },
    {
      id: "arena-8",
      kind: "prop",
      label: "Fire Barrel",
      position: { x: -19.894, z: -2.796 },
      size: { w: 0.801, d: 1.011, h: 1.15 },
      color: 0x9a4a22,
      interactable: false,
      modelUrl: "/models/objects/obj_fire-barrel.glb",
      collisionW: 0.801,
      collisionD: 1.011,
      rotationY: 3.307,
    },
    {
      id: "arena-9",
      kind: "prop",
      label: "Fire Barrel",
      position: { x: -19.405, z: -7.063 },
      size: { w: 0.801, d: 1.011, h: 1.15 },
      color: 0x9a4a22,
      interactable: false,
      modelUrl: "/models/objects/obj_fire-barrel.glb",
      collisionW: 0.801,
      collisionD: 1.011,
      rotationY: 4.677,
    },
    {
      id: "arena-10",
      kind: "prop",
      label: "Fire Barrel",
      position: { x: -8.868, z: 18.183 },
      size: { w: 0.801, d: 1.011, h: 1.15 },
      color: 0x9a4a22,
      interactable: false,
      modelUrl: "/models/objects/obj_fire-barrel.glb",
      collisionW: 0.801,
      collisionD: 1.011,
      rotationY: 6.047,
    },
    {
      id: "arena-11",
      kind: "prop",
      label: "Fire Barrel",
      position: { x: 7.864, z: 3.836 },
      size: { w: 0.801, d: 1.011, h: 1.15 },
      color: 0x9a4a22,
      interactable: false,
      modelUrl: "/models/objects/obj_fire-barrel.glb",
      collisionW: 0.801,
      collisionD: 1.011,
      rotationY: 1.134,
    },
    {
      id: "arena-12",
      kind: "prop",
      label: "Fire Barrel",
      position: { x: -8.808, z: -4.296 },
      size: { w: 0.801, d: 1.011, h: 1.15 },
      color: 0x9a4a22,
      interactable: false,
      modelUrl: "/models/objects/obj_fire-barrel.glb",
      collisionW: 0.801,
      collisionD: 1.011,
      rotationY: 2.504,
    },
    {
      id: "arena-13",
      kind: "prop",
      label: "Fire Barrel",
      position: { x: 2.095, z: -14.904 },
      size: { w: 0.801, d: 1.011, h: 1.15 },
      color: 0x9a4a22,
      interactable: false,
      modelUrl: "/models/objects/obj_fire-barrel.glb",
      collisionW: 0.801,
      collisionD: 1.011,
      rotationY: 3.874,
    },
    {
      id: "arena-14",
      kind: "prop",
      label: "Fire Barrel",
      position: { x: -1.948, z: 13.864 },
      size: { w: 0.801, d: 1.011, h: 1.15 },
      color: 0x9a4a22,
      interactable: false,
      modelUrl: "/models/objects/obj_fire-barrel.glb",
      collisionW: 0.801,
      collisionD: 1.011,
      rotationY: 5.244,
    },
    {
      id: "arena-15",
      kind: "prop",
      label: "Fire Pit",
      position: { x: -7.875, z: -13.64 },
      size: { w: 1.9, d: 1.757, h: 0.771 },
      color: 0x6a4a32,
      interactable: false,
      modelUrl: "/models/objects/obj_campfire-pit.glb",
      collisionW: 1.9,
      collisionD: 1.757,
      rotationY: 0.7,
    },
    {
      id: "pit-row1-1",
      kind: "prop",
      label: "Wreck Row Car",
      position: { x: -17.675, z: -8.133 },
      size: { w: 4.4, d: 1.877, h: 1.447 },
      color: 0x6a5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_car-rust-11.glb",
      collisionW: 4.4,
      collisionD: 1.877,
      rotationY: 4.637,
    },
    {
      id: "pit-row2-1",
      kind: "prop",
      label: "Wreck Row Car",
      position: { x: -8.535793727184778, z: -7.373510449340116 },
      size: { w: 4.4, d: 1.877, h: 1.447 },
      color: 0x6a5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_car-rust-11.glb",
      collisionW: 4.4,
      collisionD: 1.877,
      rotationY: -1.9392163570933212,
      rotationX: 0,
      rotationZ: 0,
      positionY: 0,
    },
    {
      id: "pit-row2-2",
      kind: "prop",
      label: "Wreck Row Car",
      position: { x: -3.7620723229852207, z: -5.885177073853114 },
      size: { w: 4.4, d: 1.863, h: 1.429 },
      color: 0x6a5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_car-rust-12.glb",
      collisionW: 4.4,
      collisionD: 1.863,
      rotationY: 4.709,
      rotationX: 0,
      rotationZ: 0,
      positionY: 0,
    },
    {
      id: "pit-row3-1",
      kind: "prop",
      label: "Wreck Row Car",
      position: { x: 4.965, z: -7.747 },
      size: { w: 4.4, d: 1.877, h: 1.447 },
      color: 0x6a5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_car-rust-11.glb",
      collisionW: 4.4,
      collisionD: 1.877,
      rotationY: 4.788,
    },
    {
      id: "pit-row3-2",
      kind: "prop",
      label: "Wreck Row Car",
      position: { x: 7.846, z: -8.389 },
      size: { w: 4.4, d: 1.863, h: 1.429 },
      color: 0x6a5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_car-rust-12.glb",
      collisionW: 4.4,
      collisionD: 1.863,
      rotationY: 4.646,
    },
    {
      id: "pit-row4-1",
      kind: "prop",
      label: "Wreck Row Car",
      position: { x: 17.675, z: -8.273 },
      size: { w: 4.4, d: 1.877, h: 1.447 },
      color: 0x6a5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_car-rust-11.glb",
      collisionW: 4.4,
      collisionD: 1.877,
      rotationY: 4.696,
    },
    {
      id: "pit-row5-1",
      kind: "prop",
      label: "Wreck Row Car",
      position: { x: -17.675, z: 8.278 },
      size: { w: 4.4, d: 1.877, h: 1.447 },
      color: 0x6a5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_car-rust-11.glb",
      collisionW: 4.4,
      collisionD: 1.877,
      rotationY: 4.627,
    },
    {
      id: "pit-row6-1",
      kind: "prop",
      label: "Wreck Row Car",
      position: { x: -8.05, z: 7.379 },
      size: { w: 4.4, d: 1.877, h: 1.447 },
      color: 0x6a5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_car-rust-11.glb",
      collisionW: 4.4,
      collisionD: 1.877,
      rotationY: 4.679,
      rotationX: 0,
      rotationZ: 0,
      positionY: 0,
    },
    {
      id: "pit-row6-2",
      kind: "prop",
      label: "Wreck Row Car",
      position: { x: -3.796, z: 8.056 },
      size: { w: 4.4, d: 1.863, h: 1.429 },
      color: 0x6a5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_car-rust-12.glb",
      collisionW: 4.4,
      collisionD: 1.863,
      rotationY: 1.6716030934919706,
      rotationX: 1.4346606451393404,
      rotationZ: 0,
      positionY: 0.6887653766224604,
    },
    {
      id: "pit-row7-1",
      kind: "prop",
      label: "Wreck Row Car",
      position: { x: 4.965, z: 8.163 },
      size: { w: 4.4, d: 1.877, h: 1.447 },
      color: 0x6a5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_car-rust-11.glb",
      collisionW: 4.4,
      collisionD: 1.877,
      rotationY: 4.807,
    },
    {
      id: "pit-row7-2",
      kind: "prop",
      label: "Wreck Row Car",
      position: { x: 7.846, z: 8.119 },
      size: { w: 4.4, d: 1.863, h: 1.429 },
      color: 0x6a5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_car-rust-12.glb",
      collisionW: 4.4,
      collisionD: 1.863,
      rotationY: 4.613,
    },
    {
      id: "pit-row8-1",
      kind: "prop",
      label: "Wreck Row Car",
      position: { x: 17.675, z: 8.316 },
      size: { w: 4.4, d: 1.877, h: 1.447 },
      color: 0x6a5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_car-rust-11.glb",
      collisionW: 4.4,
      collisionD: 1.877,
      rotationY: 4.627,
    },
    {
      id: "pit-row9-1",
      kind: "prop",
      label: "Wreck Row Car",
      position: { x: -18.19, z: -7.28 },
      size: { w: 4.4, d: 1.877, h: 1.447 },
      color: 0x6a5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_car-rust-11.glb",
      collisionW: 4.4,
      collisionD: 1.877,
      rotationY: 1.527,
    },
    {
      id: "pit-row10-1",
      kind: "prop",
      label: "Wreck Row Car",
      position: { x: -18.037, z: 7.28 },
      size: { w: 4.4, d: 1.877, h: 1.447 },
      color: 0x6a5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_car-rust-11.glb",
      collisionW: 4.4,
      collisionD: 1.877,
      rotationY: 1.542,
    },
    {
      id: "pit-row11-1",
      kind: "prop",
      label: "Wreck Row Car",
      position: { x: 17.942, z: -7.28 },
      size: { w: 4.4, d: 1.877, h: 1.447 },
      color: 0x6a5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_car-rust-11.glb",
      collisionW: 4.4,
      collisionD: 1.877,
      rotationY: 1.453,
    },
    {
      id: "pit-row12-1",
      kind: "prop",
      label: "Wreck Row Car",
      position: { x: 18.083, z: 7.28 },
      size: { w: 4.4, d: 1.877, h: 1.447 },
      color: 0x6a5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_car-rust-11.glb",
      collisionW: 4.4,
      collisionD: 1.877,
      rotationY: 1.568,
    },
    {
      id: "pit-heavy-1",
      kind: "prop",
      label: "Generator",
      position: { x: 20.024903567711753, z: -4.040890797443196 },
      size: { w: 1.267, d: 0.654, h: 1.062 },
      color: 0x5a5a52,
      interactable: false,
      modelUrl: "/models/objects/obj_generator.glb",
      rotationY: 1.379,
      rotationX: 0,
      rotationZ: 0,
      positionY: 0,
    },
    {
      id: "pit-heavy-2",
      kind: "prop",
      label: "Crate Stack",
      position: { x: 9.257982231889336, z: -11.037523108442754 },
      size: { w: 1.141, d: 1.141, h: 0.945 },
      color: 0x8a6b3f,
      interactable: false,
      modelUrl: "/models/objects/obj_crate-wood.glb",
      rotationY: 2.094,
      rotationX: 0,
      rotationZ: 0,
      positionY: 0,
    },
    {
      id: "pit-heavy-3",
      kind: "prop",
      label: "Concrete Blocks",
      position: { x: -9.836, z: 4.875 },
      size: { w: 1.562, d: 0.893, h: 0.79 },
      color: 0x8f8b80,
      interactable: false,
      modelUrl: "/models/objects/obj_blocks-stack.glb",
      rotationY: 0.907,
    },
    {
      id: "pit-heavy-4",
      kind: "prop",
      label: "Tyre Pile",
      position: { x: 19.041, z: 3.373 },
      size: { w: 2.167, d: 1.957, h: 0.918 },
      color: 0x2c2c2c,
      interactable: false,
      modelUrl: "/models/objects/obj_tyre-pile.glb",
      rotationY: 4.475,
    },
    {
      id: "pit-heavy-5",
      kind: "prop",
      label: "Crate Stack",
      position: { x: -7.916, z: 5.416 },
      size: { w: 1.038, d: 1.038, h: 0.86 },
      color: 0x8a6b3f,
      interactable: false,
      modelUrl: "/models/objects/obj_crate-wood.glb",
      rotationY: 2.177,
    },
    {
      id: "pit-heavy-6",
      kind: "prop",
      label: "Generator",
      position: { x: -15.326, z: 4.89 },
      size: { w: 1.093, d: 0.565, h: 0.917 },
      color: 0x5a5a52,
      interactable: false,
      modelUrl: "/models/objects/obj_generator.glb",
      rotationY: 0.455,
    },
    {
      id: "pit-heavy-7",
      kind: "prop",
      label: "Crate Stack",
      position: { x: 9.708, z: -4.767 },
      size: { w: 1.037, d: 1.037, h: 0.859 },
      color: 0x8a6b3f,
      interactable: false,
      modelUrl: "/models/objects/obj_crate-wood.glb",
      rotationY: 2.952,
    },
    {
      id: "pit-heavy-8",
      kind: "prop",
      label: "Generator",
      position: { x: 6.347321713125756, z: -18.023801281328385 },
      size: { w: 1.169, d: 0.603, h: 0.98 },
      color: 0x5a5a52,
      interactable: false,
      modelUrl: "/models/objects/obj_generator.glb",
      rotationY: 3.948,
      rotationX: 0,
      rotationZ: 0,
      positionY: 0,
    },
    {
      id: "pit-heavy-9",
      kind: "prop",
      label: "Crate Stack",
      position: { x: 5.356, z: -17.455 },
      size: { w: 1.321, d: 1.321, h: 1.095 },
      color: 0x8a6b3f,
      interactable: false,
      modelUrl: "/models/objects/obj_crate-wood.glb",
      rotationY: 3.451,
    },
    {
      id: "pit-heavy-10",
      kind: "prop",
      label: "Crate Stack",
      position: { x: 8.082, z: 11.314 },
      size: { w: 1.087, d: 1.087, h: 0.9 },
      color: 0x8a6b3f,
      interactable: false,
      modelUrl: "/models/objects/obj_crate-wood.glb",
      rotationY: 0.939,
    },
    {
      id: "pit-heavy-11",
      kind: "prop",
      label: "Concrete Blocks",
      position: { x: 16.277, z: 3.158 },
      size: { w: 1.556, d: 0.89, h: 0.787 },
      color: 0x8f8b80,
      interactable: false,
      modelUrl: "/models/objects/obj_blocks-stack.glb",
      rotationY: 4.037,
    },
    {
      id: "pit-heavy-12",
      kind: "prop",
      label: "Concrete Blocks",
      position: { x: 8.05047535155517, z: -15.59826974065144 },
      size: { w: 1.607, d: 0.919, h: 0.813 },
      color: 0x8f8b80,
      interactable: false,
      modelUrl: "/models/objects/obj_blocks-stack.glb",
      rotationY: 2.058,
      rotationX: 0,
      rotationZ: 0,
      positionY: 0,
    },
    {
      id: "pit-mid-2",
      kind: "prop",
      label: "Crate",
      position: { x: 14.959, z: 10.084 },
      size: { w: 0.824, d: 0.824, h: 0.683 },
      color: 0x8a6b3f,
      interactable: false,
      modelUrl: "/models/objects/obj_crate-wood.glb",
      rotationY: 5.856,
    },
    {
      id: "pit-mid-3",
      kind: "prop",
      label: "Barrel",
      position: { x: -5.518671635346697, z: 3.413 },
      size: { w: 0.771, d: 0.771, h: 1.035 },
      color: 0x7d4a2e,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel.glb",
      rotationY: 5.836,
      rotationX: 0,
      rotationZ: 0,
      positionY: 0,
    },
    {
      id: "pit-mid-4",
      kind: "prop",
      label: "Bucket",
      position: { x: 10.851704454868127, z: 3.9458619196880624 },
      size: { w: 0.29, d: 0.354, h: 0.395 },
      color: 0x6a6a62,
      interactable: false,
      modelUrl: "/models/objects/obj_bucket-metal.glb",
      rotationY: 0.157,
      rotationX: 0,
      rotationZ: 0,
      noClip: true,
      positionY: 0,
    },
    {
      id: "pit-mid-5",
      kind: "prop",
      label: "Wheelbarrow",
      position: { x: 15.39, z: -5.793 },
      size: { w: 1.473, d: 0.728, h: 0.576 },
      color: 0x6b5a3f,
      interactable: false,
      modelUrl: "/models/objects/obj_wheelbarrow.glb",
      rotationY: 4.541,
    },
    {
      id: "pit-mid-6",
      kind: "prop",
      label: "Barrel",
      position: { x: 17.475, z: 3.373 },
      size: { w: 0.686, d: 0.686, h: 0.921 },
      color: 0x7d4a2e,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel.glb",
      rotationY: 1.758,
    },
    {
      id: "pit-mid-7",
      kind: "prop",
      label: "Car Seat",
      position: { x: 5.937374627502662, z: -5.470731116812315 },
      size: { w: 0.59, d: 0.82, h: 0.957 },
      color: 0x5a4a42,
      interactable: false,
      modelUrl: "/models/objects/obj_carseat.glb",
      rotationY: -0.9966547859932161,
      rotationX: 0,
      rotationZ: 0,
      positionY: 0,
    },
    {
      id: "pit-mid-8",
      kind: "prop",
      label: "Barrel",
      position: { x: 7.434538238139894, z: -13.10878471683784 },
      size: { w: 0.768, d: 0.768, h: 1.031 },
      color: 0x7d4a2e,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel.glb",
      rotationY: 5.548,
      rotationX: 0,
      rotationZ: 0,
      positionY: 0,
    },
    {
      id: "pit-mid-9",
      kind: "prop",
      label: "Car Seat",
      position: { x: -10.202827300395835, z: 10.540565514738395 },
      size: { w: 0.523, d: 0.727, h: 0.849 },
      color: 0x5a4a42,
      interactable: false,
      modelUrl: "/models/objects/obj_carseat.glb",
      rotationY: 0.399,
      rotationX: 0,
      rotationZ: 0,
      positionY: 0,
    },
    {
      id: "pit-mid-10",
      kind: "prop",
      label: "Barrel",
      position: { x: -5.306, z: -5.332 },
      size: { w: 0.658, d: 0.658, h: 0.883 },
      color: 0x7d4a2e,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel.glb",
      rotationY: 5.268,
    },
    {
      id: "pit-mid-11",
      kind: "prop",
      label: "Barrel",
      position: { x: -6.702, z: -3.579 },
      size: { w: 0.665, d: 0.665, h: 0.893 },
      color: 0x7d4a2e,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel.glb",
      rotationY: 3.021,
    },
    {
      id: "pit-mid-12",
      kind: "prop",
      label: "Bucket",
      position: { x: -9.619, z: -4.345 },
      size: { w: 0.275, d: 0.336, h: 0.375 },
      color: 0x6a6a62,
      interactable: false,
      modelUrl: "/models/objects/obj_bucket-metal.glb",
      rotationY: 4.521,
    },
    {
      id: "pit-mid-16",
      kind: "prop",
      label: "Toolbox",
      position: { x: 7.716, z: -4.362 },
      size: { w: 0.556, d: 0.473, h: 0.438 },
      color: 0x4f4f4f,
      interactable: false,
      modelUrl: "/models/objects/obj_toolbox.glb",
      rotationY: 4.427,
    },
    {
      id: "pit-mid-17",
      kind: "prop",
      label: "Toolbox",
      position: { x: -15.225, z: 6.648 },
      size: { w: 0.711, d: 0.605, h: 0.56 },
      color: 0x4f4f4f,
      interactable: false,
      modelUrl: "/models/objects/obj_toolbox.glb",
      rotationY: 5.272,
    },
    {
      id: "pit-mid-18",
      kind: "prop",
      label: "Broken Chair",
      position: { x: 17.032, z: 4.679 },
      size: { w: 0.434, d: 0.383, h: 0.778 },
      color: 0x6b5540,
      interactable: false,
      modelUrl: "/models/objects/obj_chair-broken.glb",
      rotationY: 4.174,
    },
    {
      id: "pit-mid-19",
      kind: "prop",
      label: "Barrel",
      position: { x: 4.323, z: 3.016 },
      size: { w: 0.661, d: 0.661, h: 0.887 },
      color: 0x7d4a2e,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel.glb",
      rotationY: 2.827,
    },
    {
      id: "pit-mid-23",
      kind: "prop",
      label: "Sandbag",
      position: { x: -9.944, z: 16.418 },
      size: { w: 0.855, d: 0.558, h: 0.307 },
      color: 0x7a6f52,
      interactable: false,
      modelUrl: "/models/objects/obj_sandbag.glb",
      rotationY: 5.149,
    },
    {
      id: "pit-mid-25",
      kind: "prop",
      label: "Bike Wheel",
      position: { x: 7.48, z: 2.852 },
      size: { w: 0.862, d: 0.091, h: 0.764 },
      color: 0x2c2c2c,
      interactable: false,
      modelUrl: "/models/objects/obj_wheel-bike.glb",
      rotationY: 5.488,
    },
    {
      id: "pit-mid-26",
      kind: "prop",
      label: "Toolbox",
      position: { x: 5.264871758185983, z: 1.7010328448803018 },
      size: { w: 0.627, d: 0.534, h: 0.494 },
      color: 0x4f4f4f,
      interactable: false,
      modelUrl: "/models/objects/obj_toolbox.glb",
      rotationY: 6.139,
      rotationX: 0,
      rotationZ: 0,
      positionY: 0,
    },
    {
      id: "pit-mid-27",
      kind: "prop",
      label: "Rope Coil",
      position: { x: -2.2624122742774158, z: 6.592924722683873 },
      size: { w: 0.605, d: 0.51, h: 0.441 },
      color: 0x8a7550,
      interactable: false,
      modelUrl: "/models/objects/obj_rope-coil.glb",
      rotationY: 2.88,
      rotationX: 0,
      rotationZ: 0,
      positionY: 0,
    },
    {
      id: "pit-mid-28",
      kind: "prop",
      label: "Car Seat",
      position: { x: -3.389464606046186, z: 1.6781246772162364 },
      size: { w: 0.51, d: 0.709, h: 0.828 },
      color: 0x5a4a42,
      interactable: false,
      modelUrl: "/models/objects/obj_carseat.glb",
      rotationY: 0.113,
      rotationX: 0,
      rotationZ: 0,
      positionY: 0,
    },
    {
      id: "pit-mid-29",
      kind: "prop",
      label: "Rope Coil",
      position: { x: 6.873371906469693, z: 1.012797870511759 },
      size: { w: 0.633, d: 0.534, h: 0.462 },
      color: 0x8a7550,
      interactable: false,
      modelUrl: "/models/objects/obj_rope-coil.glb",
      rotationY: 3.233,
      rotationX: 0,
      rotationZ: 0,
      positionY: 0,
    },
    {
      id: "pit-mid-30",
      kind: "prop",
      label: "Broken Chair",
      position: { x: -9.542, z: 17.068 },
      size: { w: 0.494, d: 0.435, h: 0.885 },
      color: 0x6b5540,
      interactable: false,
      modelUrl: "/models/objects/obj_chair-broken.glb",
      rotationY: 0.315,
    },
    {
      id: "pit-mid-31",
      kind: "prop",
      label: "Broken Chair",
      position: { x: 3.483, z: 5.811 },
      size: { w: 0.377, d: 0.333, h: 0.676 },
      color: 0x6b5540,
      interactable: false,
      modelUrl: "/models/objects/obj_chair-broken.glb",
      rotationY: 5.571,
    },
    {
      id: "pit-mid-32",
      kind: "prop",
      label: "Car Seat",
      position: { x: -18.777, z: 4.783 },
      size: { w: 0.581, d: 0.808, h: 0.943 },
      color: 0x5a4a42,
      interactable: false,
      modelUrl: "/models/objects/obj_carseat.glb",
      rotationY: 2.823,
    },
    {
      id: "pit-mid-34",
      kind: "prop",
      label: "Bike Wheel",
      position: { x: 4.915, z: -3.879 },
      size: { w: 0.617, d: 0.065, h: 0.547 },
      color: 0x2c2c2c,
      interactable: false,
      modelUrl: "/models/objects/obj_wheel-bike.glb",
      rotationY: 4.104,
    },
    {
      id: "pit-mid-36",
      kind: "prop",
      label: "Toolbox",
      position: { x: 11.02226011761944, z: 4.8019521302474635 },
      size: { w: 0.674, d: 0.574, h: 0.531 },
      color: 0x4f4f4f,
      interactable: false,
      modelUrl: "/models/objects/obj_toolbox.glb",
      rotationY: 2.076,
      rotationX: 0,
      rotationZ: 0,
      positionY: 0,
    },
    {
      id: "pit-mid-37",
      kind: "prop",
      label: "Bike Wheel",
      position: { x: -5.991, z: 10.369 },
      size: { w: 0.613, d: 0.065, h: 0.544 },
      color: 0x2c2c2c,
      interactable: false,
      modelUrl: "/models/objects/obj_wheel-bike.glb",
      rotationY: 4.682,
    },
    {
      id: "pit-litter-1",
      kind: "prop",
      label: "Bottle Crate",
      position: { x: -19.245, z: -5.07 },
      size: { w: 0.42, d: 0.42, h: 0.351 },
      color: 0x6a7a8a,
      interactable: false,
      modelUrl: "/models/objects/obj_crate-milk.glb",
      rotationY: 0.729,
      noClip: true,
    },
    {
      id: "pit-litter-2",
      kind: "prop",
      label: "Books",
      position: { x: 6.49, z: 16.608 },
      size: { w: 0.438, d: 0.363, h: 0.275 },
      color: 0x6a5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_books-stack.glb",
      rotationY: 2.099,
      noClip: true,
    },
    {
      id: "pit-litter-3",
      kind: "prop",
      label: "Board",
      position: { x: -10.31, z: -10.059 },
      size: { w: 0.581, d: 0.337, h: 0.048 },
      color: 0x7a5f3f,
      interactable: false,
      modelUrl: "/models/objects/obj_board-chopping.glb",
      rotationY: 0.485,
      noClip: true,
    },
    {
      id: "pit-litter-4",
      kind: "prop",
      label: "Cushion",
      position: { x: 17.71398740122461, z: 4.083804047533518 },
      size: { w: 0.368, d: 0.412, h: 0.125 },
      color: 0x7a5a52,
      interactable: false,
      modelUrl: "/models/objects/obj_cushion.glb",
      rotationY: 1.959,
      rotationX: 0,
      rotationZ: 0,
      noClip: true,
      positionY: 0,
    },
    {
      id: "pit-litter-5",
      kind: "prop",
      label: "Pans",
      position: { x: 10.396, z: 8.336 },
      size: { w: 0.427, d: 0.346, h: 0.178 },
      color: 0x6a6a62,
      interactable: false,
      modelUrl: "/models/objects/obj_pans-stack.glb",
      rotationY: 0.806,
      noClip: true,
    },
    {
      id: "pit-litter-6",
      kind: "prop",
      label: "Cushion",
      position: { x: 17.202, z: 2.431 },
      size: { w: 0.484, d: 0.541, h: 0.164 },
      color: 0x7a5a52,
      interactable: false,
      modelUrl: "/models/objects/obj_cushion.glb",
      rotationY: 3.809,
      noClip: true,
    },
    {
      id: "pit-litter-7",
      kind: "prop",
      label: "Lantern",
      position: { x: 17.148, z: -3.432 },
      size: { w: 0.159, d: 0.159, h: 0.3 },
      color: 0x8a7a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_lantern-oil.glb",
      rotationY: 2.777,
      noClip: true,
    },
    {
      id: "pit-litter-8",
      kind: "prop",
      label: "Cans",
      position: { x: 5.621, z: -11.218 },
      size: { w: 0.215, d: 0.076, h: 0.252 },
      color: 0x8a8a7a,
      interactable: false,
      modelUrl: "/models/objects/obj_cans-pyramid.glb",
      rotationY: 0.23,
      noClip: true,
    },
    {
      id: "pit-litter-9",
      kind: "prop",
      label: "Lantern",
      position: { x: 16.541, z: 4.328 },
      size: { w: 0.158, d: 0.158, h: 0.3 },
      color: 0x8a7a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_lantern-oil.glb",
      rotationY: 3.002,
      noClip: true,
    },
    {
      id: "pit-litter-11",
      kind: "prop",
      label: "Lantern",
      position: { x: -2.382, z: -3.219 },
      size: { w: 0.156, d: 0.156, h: 0.296 },
      color: 0x8a7a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_lantern-oil.glb",
      rotationY: 2.896,
      noClip: true,
    },
    {
      id: "pit-litter-13",
      kind: "prop",
      label: "Board",
      position: { x: 8.483, z: -4.778 },
      size: { w: 0.423, d: 0.245, h: 0.035 },
      color: 0x7a5f3f,
      interactable: false,
      modelUrl: "/models/objects/obj_board-chopping.glb",
      rotationY: 5.889,
      noClip: true,
    },
    {
      id: "pit-litter-14",
      kind: "prop",
      label: "Spade",
      position: { x: -5.133, z: 10.479 },
      size: { w: 0.447, d: 0.037, h: 0.988 },
      color: 0x5a4a3a,
      interactable: false,
      modelUrl: "/models/objects/obj_spade.glb",
      rotationY: 5.69,
      noClip: true,
    },
    {
      id: "pit-litter-15",
      kind: "prop",
      label: "Books",
      position: { x: 16.641128957999335, z: 3.578626390598032 },
      size: { w: 0.469, d: 0.388, h: 0.294 },
      color: 0x6a5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_books-stack.glb",
      rotationY: 3.043,
      rotationX: 0,
      rotationZ: 0,
      noClip: true,
      positionY: 0,
    },
    {
      id: "pit-litter-17",
      kind: "prop",
      label: "Cans",
      position: { x: 2.57, z: 10.394 },
      size: { w: 0.275, d: 0.097, h: 0.323 },
      color: 0x8a8a7a,
      interactable: false,
      modelUrl: "/models/objects/obj_cans-pyramid.glb",
      rotationY: 1.326,
      noClip: true,
    },
    {
      id: "pit-litter-18",
      kind: "prop",
      label: "Bottle Crate",
      position: { x: 5.924, z: 17.403 },
      size: { w: 0.421, d: 0.421, h: 0.352 },
      color: 0x6a7a8a,
      interactable: false,
      modelUrl: "/models/objects/obj_crate-milk.glb",
      rotationY: 4.969,
      noClip: true,
    },
    {
      id: "pit-litter-19",
      kind: "prop",
      label: "Lantern",
      position: { x: -16.977, z: -11.873 },
      size: { w: 0.157, d: 0.157, h: 0.297 },
      color: 0x8a7a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_lantern-oil.glb",
      rotationY: 3.042,
      noClip: true,
    },
    {
      id: "pit-litter-21",
      kind: "prop",
      label: "Cans",
      position: { x: 9.151, z: 11.676 },
      size: { w: 0.21, d: 0.074, h: 0.247 },
      color: 0x8a8a7a,
      interactable: false,
      modelUrl: "/models/objects/obj_cans-pyramid.glb",
      rotationY: 1.321,
      noClip: true,
    },
    {
      id: "pit-litter-22",
      kind: "prop",
      label: "Cans",
      position: { x: 5.753, z: 3.271 },
      size: { w: 0.213, d: 0.075, h: 0.25 },
      color: 0x8a8a7a,
      interactable: false,
      modelUrl: "/models/objects/obj_cans-pyramid.glb",
      rotationY: 1.401,
      noClip: true,
    },
    {
      id: "pit-litter-23",
      kind: "prop",
      label: "Rake",
      position: { x: 3.51, z: 5.128 },
      size: { w: 0.438, d: 0.253, h: 0.874 },
      color: 0x5a4a3a,
      interactable: false,
      modelUrl: "/models/objects/obj_rake.glb",
      rotationY: 1.825,
      noClip: true,
    },
    {
      id: "pit-litter-24",
      kind: "prop",
      label: "Lantern",
      position: { x: 2.378, z: 17.918 },
      size: { w: 0.177, d: 0.177, h: 0.334 },
      color: 0x8a7a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_lantern-oil.glb",
      rotationY: 3.132,
      noClip: true,
    },
    {
      id: "pit-litter-26",
      kind: "prop",
      label: "Books",
      position: { x: 6.582, z: 11.31 },
      size: { w: 0.427, d: 0.354, h: 0.268 },
      color: 0x6a5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_books-stack.glb",
      rotationY: 3.797,
      noClip: true,
    },
    {
      id: "pit-litter-27",
      kind: "prop",
      label: "Cans",
      position: { x: 8.509, z: -5.859 },
      size: { w: 0.297, d: 0.105, h: 0.348 },
      color: 0x8a8a7a,
      interactable: false,
      modelUrl: "/models/objects/obj_cans-pyramid.glb",
      rotationY: 4.588,
      noClip: true,
    },
    {
      id: "pit-litter-28",
      kind: "prop",
      label: "Spade",
      position: { x: -15.244, z: -6.562 },
      size: { w: 0.347, d: 0.029, h: 0.767 },
      color: 0x5a4a3a,
      interactable: false,
      modelUrl: "/models/objects/obj_spade.glb",
      rotationY: 3.663,
      noClip: true,
    },
    {
      id: "pit-litter-29",
      kind: "prop",
      label: "Pans",
      position: { x: 19.909, z: 1.488 },
      size: { w: 0.565, d: 0.458, h: 0.235 },
      color: 0x6a6a62,
      interactable: false,
      modelUrl: "/models/objects/obj_pans-stack.glb",
      rotationY: 2.668,
      noClip: true,
    },
    {
      id: "pit-litter-30",
      kind: "prop",
      label: "Scrap",
      position: { x: 3.861, z: -3.673 },
      size: { w: 1.459, d: 1.482, h: 0.302 },
      color: 0x9a8a6a,
      interactable: false,
      modelUrl: "/models/items/item_scrap.glb",
      rotationY: 2.078,
      noClip: true,
    },
    {
      id: "pit-litter-31",
      kind: "prop",
      label: "Spade",
      position: { x: 17.544, z: 4.492 },
      size: { w: 0.44, d: 0.037, h: 0.971 },
      color: 0x5a4a3a,
      interactable: false,
      modelUrl: "/models/objects/obj_spade.glb",
      rotationY: 3.046,
      noClip: true,
    },
    {
      id: "pit-litter-32",
      kind: "prop",
      label: "Pans",
      position: { x: 15.177126346673138, z: 11.135278759308589 },
      size: { w: 0.418, d: 0.339, h: 0.174 },
      color: 0x6a6a62,
      interactable: false,
      modelUrl: "/models/objects/obj_pans-stack.glb",
      rotationY: 0.96,
      rotationX: 0,
      rotationZ: 0,
      noClip: true,
      positionY: 0,
    },
    {
      id: "pit-litter-34",
      kind: "prop",
      label: "Board",
      position: { x: 6.565, z: 3.852 },
      size: { w: 0.415, d: 0.241, h: 0.034 },
      color: 0x7a5f3f,
      interactable: false,
      modelUrl: "/models/objects/obj_board-chopping.glb",
      rotationY: 4.305,
      noClip: true,
    },
    {
      id: "pit-litter-35",
      kind: "prop",
      label: "Cushion",
      position: { x: 3.109, z: -17.213 },
      size: { w: 0.49, d: 0.548, h: 0.166 },
      color: 0x7a5a52,
      interactable: false,
      modelUrl: "/models/objects/obj_cushion.glb",
      rotationY: 1.853,
      noClip: true,
    },
    {
      id: "pit-litter-36",
      kind: "prop",
      label: "Cushion",
      position: { x: 8.708, z: -5.113 },
      size: { w: 0.487, d: 0.545, h: 0.165 },
      color: 0x7a5a52,
      interactable: false,
      modelUrl: "/models/objects/obj_cushion.glb",
      rotationY: 2.527,
      noClip: true,
    },
    {
      id: "object-mu4erk4d",
      kind: "prop",
      label: "Pickup",
      position: { x: 4.576, z: -8.022 },
      size: { w: 4.194, d: 1.87, h: 1.85 },
      color: 0x9a8a6a,
      interactable: false,
      modelUrl: "/models/vehicles/veh_pickup.glb",
      rotationY: -1.5064839318329222,
      rotationX: 0,
      rotationZ: 0,
      positionY: 0.9546927959454852,
    },
    {
      id: "object-mu4es8b8",
      kind: "prop",
      label: "Car-rust-28-suv",
      position: { x: -3.9, z: 8.136 },
      size: { w: 4.512, d: 3.15, h: 1.5099999999999998 },
      color: 0x9a8a6a,
      interactable: false,
      modelUrl: "/models/objects/obj_car-rust-28-suv.glb",
      rotationY: 1.53957435037711,
      rotationX: -3.141592653589793,
      rotationZ: -3.141592653589793,
      positionY: -0.03743264480625541,
    },
    {
      id: "object-mu4etga0",
      kind: "prop",
      label: "Car-rust-4",
      position: { x: -6.173, z: 7.906 },
      size: { w: 4.576, d: 3.293, h: 1.5 },
      color: 0x9a8a6a,
      interactable: false,
      modelUrl: "/models/objects/obj_car-rust-4.glb",
      rotationY: 1.441369357547603,
      rotationX: -3.141592653589793,
      rotationZ: -3.141592653589793,
      positionY: 0,
    },
    {
      id: "object-mu4ev0ls",
      kind: "prop",
      label: "Car-rust-20",
      position: { x: -9.835, z: 7.868 },
      size: { w: 1.971, d: 4.418, h: 1.5 },
      color: 0x9a8a6a,
      interactable: false,
      modelUrl: "/models/objects/obj_car-rust-20.glb",
      rotationY: 0,
      rotationX: 0,
      rotationZ: 0,
      positionY: 0,
    },
    {
      id: "object-mu4evt0w",
      kind: "prop",
      label: "Car-rust-41",
      position: { x: 6.80050567139815, z: 7.95 },
      size: { w: 4.775, d: 1.99, h: 1.5 },
      color: 0x9a8a6a,
      interactable: false,
      modelUrl: "/models/objects/obj_car-rust-41.glb",
      rotationY: 0,
      rotationX: 0,
      rotationZ: 0,
      positionY: 1.278580116914741,
    },
    {
      id: "object-mu4ex4q0",
      kind: "building",
      label: "Smith",
      position: { x: 17.538, z: -0.13 },
      size: { w: 5.394, d: 5.325, h: 4 },
      color: 0x9a8a6a,
      interactable: false,
      modelUrl: "/models/buildings/building_smith.glb",
      rotationY: -0.04911850181205552,
      rotationX: 0,
      rotationZ: 0,
      positionY: 0,
    },
    {
      id: "object-mu4eyby0",
      kind: "prop",
      label: "Car-rust-66-limo",
      position: { x: -5.355, z: -15.189 },
      size: { w: 2.139, d: 5.522, h: 1.4 },
      color: 0x9a8a6a,
      interactable: false,
      modelUrl: "/models/objects/obj_car-rust-66-limo.glb",
      rotationY: -0.9337511498169663,
      rotationX: 0,
      rotationZ: -0.19198621771937624,
      positionY: 0.10721315463451964,
    },
    {
      id: "object-mvax7rmy",
      kind: "prop",
      label: "Bike_tourer",
      position: { x: -1.501337451584737, z: -9.689068678972104 },
      size: { w: 2.039, d: 0.86, h: 1.3 },
      color: 0x9a8a6a,
      interactable: false,
      modelUrl: "/models/objects/obj_bike_tourer.glb",
      rotationY: -1.010868084774771,
      rotationX: 0,
      rotationZ: 0,
      positionY: 0,
    },
    {
      id: "object-mvax8sk3",
      kind: "prop",
      label: "Crates",
      position: { x: -1.672728835817653, z: 9.09232693357386 },
      size: { w: 2.002, d: 1.906, h: 1.1 },
      color: 0x9a8a6a,
      interactable: false,
      modelUrl: "/models/objects/obj_crates.glb",
      rotationY: -0.3938788589192945,
      rotationX: 0,
      rotationZ: 0,
      positionY: 0,
    },
    {
      id: "object-mvaykjib",
      kind: "prop",
      label: "Barrel",
      position: { x: -0.010096608778422222, z: 0.020420782408901772 },
      size: { w: 0.615, d: 0.615, h: 0.8250000000000001 },
      color: 0x9a8a6a,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel.glb",
    },
    {
      id: "object-mvaylrik",
      kind: "prop",
      label: "Bike_street",
      position: { x: -8.511642353089275, z: 10.021079450474058 },
      size: { w: 2.085, d: 0.828, h: 1.15 },
      color: 0x9a8a6a,
      interactable: false,
      modelUrl: "/models/objects/obj_bike_street.glb",
      rotationY: 0.3839310788930265,
      rotationX: 0,
      rotationZ: 0,
      positionY: 0,
    },
    {
      id: "object-mvaym4dy",
      kind: "prop",
      label: "Bike_street_modern",
      position: { x: -7.782803198289954, z: 10.482658379100137 },
      size: { w: 1.885, d: 0.841, h: 1.15 },
      color: 0x9a8a6a,
      interactable: false,
      modelUrl: "/models/objects/obj_bike_street_modern.glb",
      rotationY: 0,
      rotationX: 0,
      rotationZ: 0,
      positionY: 0,
    },
    {
      id: "object-mvaymh2w",
      kind: "prop",
      label: "Carseat-2",
      position: { x: -9.719777492935847, z: 9.047879786953118 },
      size: { w: 0.632, d: 0.86, h: 1.0924999999999998 },
      color: 0x9a8a6a,
      interactable: false,
      modelUrl: "/models/objects/obj_carseat-2.glb",
      rotationY: -0.7839900934107772,
      rotationX: 0.17453292519943295,
      rotationZ: 0,
      positionY: 0.9123986282261516,
    },
  ],

  decals: [
    {
      id: "arena-decal-1",
      label: "Puddle",
      textureUrl: "/decals/puddle.webp",
      position: { x: 6.282, z: 13.213 },
      size: { w: 2.807, d: 2.524 },
      rotationY: 5.971,
      opacity: 0.4,
    },
    {
      id: "arena-decal-2",
      label: "Puddle",
      textureUrl: "/decals/puddle.webp",
      position: { x: 12.077, z: -9.033 },
      size: { w: 2.217, d: 1.706 },
      rotationY: 5.889,
      opacity: 0.4,
    },
    {
      id: "arena-decal-3",
      label: "Paper",
      textureUrl: "/decals/newspaper.webp",
      position: { x: -16.7, z: -2.28 },
      size: { w: 0.715, d: 0.78 },
      rotationY: 5.682,
      opacity: 0.7,
    },
    {
      id: "arena-decal-4",
      label: "Paper",
      textureUrl: "/decals/newspaper.webp",
      position: { x: 15.495, z: -2.621 },
      size: { w: 0.521, d: 0.61 },
      rotationY: 4.799,
      opacity: 0.7,
    },
    {
      id: "arena-decal-5",
      label: "Puddle",
      textureUrl: "/decals/puddle.webp",
      position: { x: -13.245, z: -6.47 },
      size: { w: 1.862, d: 1.835 },
      rotationY: 0.205,
      opacity: 0.4,
    },
    {
      id: "arena-decal-6",
      label: "Paper",
      textureUrl: "/decals/newspaper.webp",
      position: { x: 17.737, z: 10.51 },
      size: { w: 0.518, d: 0.529 },
      rotationY: 1.902,
      opacity: 0.7,
    },
    {
      id: "arena-decal-7",
      label: "Paper",
      textureUrl: "/decals/newspaper.webp",
      position: { x: -2.073, z: -19.637 },
      size: { w: 0.888, d: 0.93 },
      rotationY: 3.594,
      opacity: 0.7,
    },
    {
      id: "arena-decal-8",
      label: "Puddle",
      textureUrl: "/decals/puddle.webp",
      position: { x: 13.433, z: -6.944 },
      size: { w: 2.973, d: 3.629 },
      rotationY: 0.809,
      opacity: 0.4,
    },
    {
      id: "arena-decal-9",
      label: "Paper",
      textureUrl: "/decals/newspaper.webp",
      position: { x: 15.979, z: 2.753 },
      size: { w: 1.024, d: 0.895 },
      rotationY: 4.013,
      opacity: 0.7,
    },
    {
      id: "arena-decal-10",
      label: "Paper",
      textureUrl: "/decals/newspaper.webp",
      position: { x: -11.916, z: 1.227 },
      size: { w: 0.707, d: 0.53 },
      rotationY: 2.731,
      opacity: 0.7,
    },
    {
      id: "arena-decal-11",
      label: "Puddle",
      textureUrl: "/decals/puddle.webp",
      position: { x: 12.192, z: 5.447 },
      size: { w: 1.615, d: 1.445 },
      rotationY: 2.806,
      opacity: 0.4,
    },
    {
      id: "arena-decal-12",
      label: "Puddle",
      textureUrl: "/decals/puddle.webp",
      position: { x: -11.268, z: -10.355 },
      size: { w: 2.704, d: 2.071 },
      rotationY: 5.344,
      opacity: 0.4,
    },
    {
      id: "arena-decal-13",
      label: "Paper",
      textureUrl: "/decals/newspaper.webp",
      position: { x: -7.668, z: -11.339 },
      size: { w: 0.64, d: 0.701 },
      rotationY: 5.924,
      opacity: 0.7,
    },
    {
      id: "arena-decal-14",
      label: "Puddle",
      textureUrl: "/decals/puddle.webp",
      position: { x: -8.527, z: 14.241 },
      size: { w: 1.938, d: 2.227 },
      rotationY: 4.775,
      opacity: 0.4,
    },
    {
      id: "arena-decal-15",
      label: "Puddle",
      textureUrl: "/decals/puddle.webp",
      position: { x: 13.382, z: -15.16 },
      size: { w: 2.082, d: 2.284 },
      rotationY: 4.759,
      opacity: 0.4,
    },
    {
      id: "arena-decal-16",
      label: "Paper",
      textureUrl: "/decals/newspaper.webp",
      position: { x: 7.041, z: 17.87 },
      size: { w: 0.778, d: 0.886 },
      rotationY: 4.666,
      opacity: 0.7,
    },
    {
      id: "arena-decal-17",
      label: "Paper",
      textureUrl: "/decals/newspaper.webp",
      position: { x: -16.749, z: 10.703 },
      size: { w: 0.977, d: 1.087 },
      rotationY: 1.994,
      opacity: 0.7,
    },
  ],

  roads: [
    {
      id: "arena-lane-centre",
      label: "Centre Lane",
      surface: "dirt_path",
      points: [{ x: 0, z: -21 }, { x: 0, z: 21 }],
      width: 3.731,
      opacity: 0.68,
    },
    {
      id: "arena-lane-west",
      label: "West Lane",
      surface: "dirt_path",
      points: [{ x: -12.6, z: -17.5 }, { x: -12.6, z: 17.5 }],
      width: 3.157,
      opacity: 0.58,
    },
    {
      id: "arena-lane-east",
      label: "East Lane",
      surface: "dirt_path",
      points: [{ x: 12.6, z: -17.5 }, { x: 12.6, z: 17.5 }],
      width: 3.157,
      opacity: 0.58,
    },
    {
      id: "arena-lane-cross",
      label: "Cross Lane",
      surface: "dirt_path",
      points: [{ x: -17.5, z: 0 }, { x: 17.5, z: 0 }],
      width: 3.444,
      opacity: 0.6,
    },
    {
      id: "arena-lane-rim",
      label: "Rim Track",
      surface: "dirt_road",
      points: [{ x: -16.1, z: -14 }, { x: 16.1, z: -14 }],
      width: 2.64,
      opacity: 0.45,
    },
    {
      id: "arena-lane-rim2",
      label: "Rim Track",
      surface: "dirt_road",
      points: [{ x: -16.1, z: 14 }, { x: 16.1, z: 14 }],
      width: 2.64,
      opacity: 0.45,
    },
  ],

  spriteSpawns: [
    {
      id: "arena-fire-1",
      label: "Barrel Fire",
      sheet: "fire",
      position: { x: 2.845, z: 20.241 },
      positionY: 0.75,
      width: 1.15,
      height: 1.7,
      opacity: 0.95,
    },
    {
      id: "arena-fire-2",
      label: "Barrel Fire",
      sheet: "fire",
      position: { x: 14.502, z: 14.004 },
      positionY: 0.75,
      width: 1.15,
      height: 1.7,
      opacity: 0.95,
    },
    {
      id: "arena-fire-4",
      label: "Barrel Fire",
      sheet: "fire",
      position: { x: 20.65, z: 0 },
      positionY: 0.75,
      width: 1.15,
      height: 1.7,
      opacity: 0.95,
    },
    {
      id: "arena-fire-5",
      label: "Barrel Fire",
      sheet: "fire",
      position: { x: 9.616190129815582, z: -18.20390434392066 },
      positionY: 0.7500000000000001,
      width: 1.15,
      height: 1.7,
      opacity: 0.95,
    },
    {
      id: "arena-fire-7",
      label: "Barrel Fire",
      sheet: "fire",
      position: { x: -14.754, z: -14.247 },
      positionY: 0.75,
      width: 1.15,
      height: 1.7,
      opacity: 0.95,
    },
    {
      id: "arena-fire-8",
      label: "Barrel Fire",
      sheet: "fire",
      position: { x: -19.894, z: -2.796 },
      positionY: 0.75,
      width: 1.15,
      height: 1.7,
      opacity: 0.95,
    },
    {
      id: "arena-fire-10",
      label: "Barrel Fire",
      sheet: "fire",
      position: { x: -8.868, z: 18.183 },
      positionY: 0.75,
      width: 1.15,
      height: 1.7,
      opacity: 0.95,
    },
    {
      id: "arena-fire-11",
      label: "Barrel Fire",
      sheet: "fire",
      position: { x: 7.864, z: 3.836 },
      positionY: 0.75,
      width: 1.15,
      height: 1.7,
      opacity: 0.95,
    },
    {
      id: "arena-fire-12",
      label: "Barrel Fire",
      sheet: "fire",
      position: { x: -8.808, z: -4.296 },
      positionY: 0.75,
      width: 1.15,
      height: 1.7,
      opacity: 0.95,
    },
    {
      id: "arena-fire-14",
      label: "Barrel Fire",
      sheet: "fire",
      position: { x: -1.948, z: 13.864 },
      positionY: 0.75,
      width: 1.15,
      height: 1.7,
      opacity: 0.95,
    },
    {
      id: "arena-fire-pit",
      label: "Pit Fire",
      sheet: "fire",
      position: { x: -7.875, z: -13.64 },
      positionY: 0.2,
      width: 2,
      height: 2.2,
      opacity: 0.95,
    },
    {
      id: "arena-smoke-pit",
      label: "Pit Smoke",
      sheet: "smoke",
      position: { x: -7.875, z: -13.64 },
      positionY: 1.9,
      width: 3.4,
      height: 5,
      opacity: 0.4,
    },
    {
      id: "arena-smoke-dozer",
      label: "Dozer Smoke",
      sheet: "smoke",
      position: { x: -6.818, z: -16.875 },
      positionY: 2.2,
      width: 3,
      height: 4.4,
      opacity: 0.28,
    },
  ],

  playerSpawns: [
    {
      id: "pspawn-south",
      label: "Fighter 1",
      position: { x: 0, z: -16.8 },
    },
    {
      id: "pspawn-north",
      label: "Fighter 2",
      position: { x: 0, z: 16.8 },
    },
  ],

  npcs: {
  },

  dialog: {
  },
};
